export const LANGUAGE = 'lang';
export const USER_STAGE = 'stage';
export const EMAIL = 'email';
export const ADDED_COINS = 'added';
export const TOKEN = 'token';
export const IS_BATTLEINFO_EXPANDED = 'isExpanded';
export const SAVED_TEMPLATES = 'savedTemplates';
